import React from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, useRecordContext} from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { bulkAssignInfluencer } from '../../../Model/bulkAssignInfluencer'


const handleAssignClick = (selectedIds, resource, refresh, notify, unselectAll,recordData) => {
   
    const data = {
        "sid[]": selectedIds,
        "uid":recordData.id
    }
    bulkAssignInfluencer(data, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message, 'warning')
    })

}

const BulkAssignButton = ({ selectedIds, resource }) => {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    const recordData = useRecordContext()
    return (
        <Button label="Bulk Assign" style={{ color:'green',border:'1px solid'}} icon={<IconBlock />} onClick={() => {
            handleAssignClick(selectedIds, resource, refresh, notify, unselectAll,recordData)
        }} />

        
    );
}

export default BulkAssignButton